<template>
  <div
    v-if="item.introduction || item.text"
    class="grid-list"
    :class="{ 'not-video': !item.video && !item.img }"
  >
    <div>
      <TitleWidget v-if="smAndDown">
        {{ parsedTitle }}
      </TitleWidget>

      <template v-if="item.video || item.img">
        <div
          class="mt-4 mt-md-0 position-relative item-video-content"
          :class="{ 'cursor-pointer': item.video }"
        >
          <template v-if="item.video">
            <div
              v-if="!isPlaying"
              class="d-flex align-center justify-center item-video-mask"
            >
              <v-sheet
                class="
                  d-flex
                  align-center
                  justify-center
                  rounded-circle
                  pl-1 pl-md-2
                  item-video-mask-icon
                "
                color="#ffffff"
                :height="smAndDown ? '40px' : '90px'"
                :width="smAndDown ? '40px' : '90px'"
              >
                <v-icon color="secondary lighten-2" :size="smAndDown ? 20 : 40">
                  fa-play
                </v-icon>
              </v-sheet>
            </div>

            <video
              @click="(e) => playVideo(e)"
              :src="files + item.video"
              ref="video"
              width="100%"
              height="100%"
              :controls="false"
            ></video>
          </template>
          <template v-else>
            <img
              class="d-block"
              :src="files + item.img"
              :alt="parsedTitle"
              width="100%"
              height="100%"
            />
          </template>
        </div>
      </template>
    </div>

    <v-sheet class="d-flex align-center" color="primary">
      <v-sheet
        class="
          pa-6 pa-lg-10
          pl-lg-16
          white--text
          d-flex
          justify-center
          align-center
        "
        color="transparent"
        max-width="600px"
      >
        <div>
          <TitleWidget v-if="!smAndDown" align="left">
            {{ parsedTitle }}
          </TitleWidget>

          <div
            class="
              secondary--text
              text-body-2 text-lg-body-1 text-justify
              font-weight-light
              mt-5 mt-md-7
            "
            v-html="item.introduction || item.text"
          ></div>

          <ButtonWidget
            class="mt-6 mt-md-8"
            :to="path"
            color="secondary"
            text-color="secondary"
            outlined
          >
            Saiba mais
          </ButtonWidget>
        </div>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "about",
  path: "/sobre-nos",
};

const _data = {
  title: "Sobre Nós",
  path: _config.path,
  isPlaying: false,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    parsedTitle() {
      return this.item.title || this.title;
    },
  },
  methods: {
    playVideo(e) {
      const video = e.target;

      if (video.paused) {
        video.play();

        setTimeout(() => {
          this.isPlaying = true;
        }, 100);
      } else {
        video.pause();
        this.isPlaying = false;
      }
    },
  },
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
  components: {
    TitleWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 0;
  grid-template-columns: 47% 53%;

  @media screen and (max-width: 960px) {
    grid-template-columns: 1fr;
  }

  &.not-video {
    grid-template-columns: 1fr;
  }
}

.item-video-content {
  aspect-ratio: 16 / 9;

  @media screen and (min-width: 960.001px) and (max-width: 1264px) {
    aspect-ratio: 1;
  }

  img,
  video {
    display: block;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .item-video-mask {
    background-color: rgba(0, 0, 0, 0.5);
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: all 0.1s linear;

    &-icon {
      opacity: 0.9;
      transition: all 0.1s linear;
    }
  }

  &:hover {
    .item-video-mask {
      background-color: rgba(0, 0, 0, 0.2);

      &-icon {
        opacity: 1;
      }
    }
  }
}
</style>
